import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CoreModule } from './core/core.module';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AccountModule } from './account/account.module';
import { SharedModule } from './shared/shared.module';
import { KpaLayoutModule } from './kpa-layout/kpa-layout.module';
import { AuditViewModule } from './audit-view/audit-view.module';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [CoreModule, RouterOutlet, AccountModule, SharedModule, KpaLayoutModule, AuditViewModule],
	providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
	hostDirectives: [],
})
export class AppComponent implements OnInit {
	ngOnInit() {
		console.log('app-component: starting ngOnInit');
	}
}
